export default __webpack_public_path__ + "static/media/BLAZE-Logo-blue.368254bd.svg";